/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BulkReprocessFilterDto,
  BulkReprocessPreviewDto,
  BulkReprocessRunCreatedDto,
  BulkReprocessRunDto,
  BulkReprocessRunIdDto,
  BulkReprocessRunItemListDto,
  BulkReprocessRunListDto,
  CreateBulkReprocessRunDto,
  ListBulkReprocessRunItemsParams,
  ListBulkReprocessRunsParams,
  PreviewBulkReprocessParams
} from '../model';

import { customFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getPreviewBulkReprocessUrl = (params?: PreviewBulkReprocessParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/bulk-reprocess/preview?${stringifiedParams}` : `/admin/bulk-reprocess/preview`
}

export const previewBulkReprocess = async (bulkReprocessFilterDto: BulkReprocessFilterDto,
    params?: PreviewBulkReprocessParams, options?: Parameters<typeof customFetch>[1]): Promise<BulkReprocessPreviewDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BulkReprocessPreviewDto>(getPreviewBulkReprocessUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkReprocessFilterDto)
  }
);}





export const getPreviewBulkReprocessMutationKey = () => ['previewBulkReprocess'] as const;

export const getPreviewBulkReprocessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewBulkReprocess>>, TError,PreviewBulkReprocessMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewBulkReprocess>>, TError,PreviewBulkReprocessMutationVariables, TContext> => {

const mutationKey = getPreviewBulkReprocessMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewBulkReprocess>>, PreviewBulkReprocessMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  previewBulkReprocess(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewBulkReprocessMutationResult = NonNullable<Awaited<ReturnType<typeof previewBulkReprocess>>>
    export type PreviewBulkReprocessMutationBody = BulkReprocessFilterDto
    export type PreviewBulkReprocessMutationError = unknown
    export type PreviewBulkReprocessMutationVariables = {data: BulkReprocessFilterDto;params?: PreviewBulkReprocessParams}

    export const usePreviewBulkReprocess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewBulkReprocess>>, TError,PreviewBulkReprocessMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewBulkReprocess>>,
        TError,
        PreviewBulkReprocessMutationVariables,
        TContext
      > => {
      return useMutation(getPreviewBulkReprocessMutationOptions(options), queryClient);
    }
    export const getCreateBulkReprocessRunUrl = () => {




  return `/admin/bulk-reprocess`
}

export const createBulkReprocessRun = async (createBulkReprocessRunDto: CreateBulkReprocessRunDto, options?: Parameters<typeof customFetch>[1]): Promise<BulkReprocessRunCreatedDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<BulkReprocessRunCreatedDto>(getCreateBulkReprocessRunUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createBulkReprocessRunDto)
  }
);}





export const getCreateBulkReprocessRunMutationKey = () => ['createBulkReprocessRun'] as const;

export const getCreateBulkReprocessRunMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkReprocessRun>>, TError,CreateBulkReprocessRunMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkReprocessRun>>, TError,CreateBulkReprocessRunMutationVariables, TContext> => {

const mutationKey = getCreateBulkReprocessRunMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkReprocessRun>>, CreateBulkReprocessRunMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createBulkReprocessRun(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkReprocessRunMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkReprocessRun>>>
    export type CreateBulkReprocessRunMutationBody = CreateBulkReprocessRunDto
    export type CreateBulkReprocessRunMutationError = unknown
    export type CreateBulkReprocessRunMutationVariables = {data: CreateBulkReprocessRunDto}

    export const useCreateBulkReprocessRun = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkReprocessRun>>, TError,CreateBulkReprocessRunMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkReprocessRun>>,
        TError,
        CreateBulkReprocessRunMutationVariables,
        TContext
      > => {
      return useMutation(getCreateBulkReprocessRunMutationOptions(options), queryClient);
    }
    export const getListBulkReprocessRunsUrl = (params?: ListBulkReprocessRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/bulk-reprocess?${stringifiedParams}` : `/admin/bulk-reprocess`
}

export const listBulkReprocessRuns = async (params?: ListBulkReprocessRunsParams, options?: Parameters<typeof customFetch>[1]): Promise<BulkReprocessRunListDto> => {

  return customFetch<BulkReprocessRunListDto>(getListBulkReprocessRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBulkReprocessRunsQueryKey = (params?: ListBulkReprocessRunsParams,) => {
    return [
    `/admin/bulk-reprocess`, ...(params ? [params] : [])
    ] as const;
    }


export const getListBulkReprocessRunsQueryOptions = <TData = Awaited<ReturnType<typeof listBulkReprocessRuns>>, TError = unknown>(params?: ListBulkReprocessRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkReprocessRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBulkReprocessRunsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBulkReprocessRuns>>> = ({ signal }) => listBulkReprocessRuns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBulkReprocessRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBulkReprocessRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listBulkReprocessRuns>>>
export type ListBulkReprocessRunsQueryError = unknown


export function useListBulkReprocessRuns<TData = Awaited<ReturnType<typeof listBulkReprocessRuns>>, TError = unknown>(
 params: undefined |  ListBulkReprocessRunsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkReprocessRuns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBulkReprocessRuns>>,
          TError,
          Awaited<ReturnType<typeof listBulkReprocessRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBulkReprocessRuns<TData = Awaited<ReturnType<typeof listBulkReprocessRuns>>, TError = unknown>(
 params?: ListBulkReprocessRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkReprocessRuns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBulkReprocessRuns>>,
          TError,
          Awaited<ReturnType<typeof listBulkReprocessRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBulkReprocessRuns<TData = Awaited<ReturnType<typeof listBulkReprocessRuns>>, TError = unknown>(
 params?: ListBulkReprocessRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkReprocessRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListBulkReprocessRuns<TData = Awaited<ReturnType<typeof listBulkReprocessRuns>>, TError = unknown>(
 params?: ListBulkReprocessRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkReprocessRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBulkReprocessRunsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetBulkReprocessRunUrl = (id: string,) => {




  return `/admin/bulk-reprocess/${id}`
}

export const getBulkReprocessRun = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<BulkReprocessRunDto> => {

  return customFetch<BulkReprocessRunDto>(getGetBulkReprocessRunUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBulkReprocessRunQueryKey = (id: string,) => {
    return [
    `/admin/bulk-reprocess/${id}`
    ] as const;
    }


export const getGetBulkReprocessRunQueryOptions = <TData = Awaited<ReturnType<typeof getBulkReprocessRun>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkReprocessRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBulkReprocessRunQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBulkReprocessRun>>> = ({ signal }) => getBulkReprocessRun(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBulkReprocessRun>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBulkReprocessRunQueryResult = NonNullable<Awaited<ReturnType<typeof getBulkReprocessRun>>>
export type GetBulkReprocessRunQueryError = unknown


export function useGetBulkReprocessRun<TData = Awaited<ReturnType<typeof getBulkReprocessRun>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkReprocessRun>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkReprocessRun>>,
          TError,
          Awaited<ReturnType<typeof getBulkReprocessRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkReprocessRun<TData = Awaited<ReturnType<typeof getBulkReprocessRun>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkReprocessRun>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBulkReprocessRun>>,
          TError,
          Awaited<ReturnType<typeof getBulkReprocessRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBulkReprocessRun<TData = Awaited<ReturnType<typeof getBulkReprocessRun>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkReprocessRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBulkReprocessRun<TData = Awaited<ReturnType<typeof getBulkReprocessRun>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBulkReprocessRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBulkReprocessRunQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListBulkReprocessRunItemsUrl = (id: string,
    params?: ListBulkReprocessRunItemsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/bulk-reprocess/${id}/items?${stringifiedParams}` : `/admin/bulk-reprocess/${id}/items`
}

export const listBulkReprocessRunItems = async (id: string,
    params?: ListBulkReprocessRunItemsParams, options?: Parameters<typeof customFetch>[1]): Promise<BulkReprocessRunItemListDto> => {

  return customFetch<BulkReprocessRunItemListDto>(getListBulkReprocessRunItemsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBulkReprocessRunItemsQueryKey = (id: string,
    params?: ListBulkReprocessRunItemsParams,) => {
    return [
    `/admin/bulk-reprocess/${id}/items`, ...(params ? [params] : [])
    ] as const;
    }


export const getListBulkReprocessRunItemsQueryOptions = <TData = Awaited<ReturnType<typeof listBulkReprocessRunItems>>, TError = unknown>(id: string,
    params?: ListBulkReprocessRunItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkReprocessRunItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBulkReprocessRunItemsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBulkReprocessRunItems>>> = ({ signal }) => listBulkReprocessRunItems(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBulkReprocessRunItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBulkReprocessRunItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listBulkReprocessRunItems>>>
export type ListBulkReprocessRunItemsQueryError = unknown


export function useListBulkReprocessRunItems<TData = Awaited<ReturnType<typeof listBulkReprocessRunItems>>, TError = unknown>(
 id: string,
    params: undefined |  ListBulkReprocessRunItemsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkReprocessRunItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBulkReprocessRunItems>>,
          TError,
          Awaited<ReturnType<typeof listBulkReprocessRunItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBulkReprocessRunItems<TData = Awaited<ReturnType<typeof listBulkReprocessRunItems>>, TError = unknown>(
 id: string,
    params?: ListBulkReprocessRunItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkReprocessRunItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBulkReprocessRunItems>>,
          TError,
          Awaited<ReturnType<typeof listBulkReprocessRunItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBulkReprocessRunItems<TData = Awaited<ReturnType<typeof listBulkReprocessRunItems>>, TError = unknown>(
 id: string,
    params?: ListBulkReprocessRunItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkReprocessRunItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListBulkReprocessRunItems<TData = Awaited<ReturnType<typeof listBulkReprocessRunItems>>, TError = unknown>(
 id: string,
    params?: ListBulkReprocessRunItemsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBulkReprocessRunItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBulkReprocessRunItemsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRetryBulkReprocessRunUrl = (id: string,) => {




  return `/admin/bulk-reprocess/${id}/retry`
}

export const retryBulkReprocessRun = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<BulkReprocessRunIdDto> => {

  return customFetch<BulkReprocessRunIdDto>(getRetryBulkReprocessRunUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryBulkReprocessRunMutationKey = () => ['retryBulkReprocessRun'] as const;

export const getRetryBulkReprocessRunMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryBulkReprocessRun>>, TError,RetryBulkReprocessRunMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof retryBulkReprocessRun>>, TError,RetryBulkReprocessRunMutationVariables, TContext> => {

const mutationKey = getRetryBulkReprocessRunMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryBulkReprocessRun>>, RetryBulkReprocessRunMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  retryBulkReprocessRun(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryBulkReprocessRunMutationResult = NonNullable<Awaited<ReturnType<typeof retryBulkReprocessRun>>>

    export type RetryBulkReprocessRunMutationError = unknown
    export type RetryBulkReprocessRunMutationVariables = {id: string}

    export const useRetryBulkReprocessRun = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryBulkReprocessRun>>, TError,RetryBulkReprocessRunMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryBulkReprocessRun>>,
        TError,
        RetryBulkReprocessRunMutationVariables,
        TContext
      > => {
      return useMutation(getRetryBulkReprocessRunMutationOptions(options), queryClient);
    }
    export const getCancelBulkReprocessRunUrl = (id: string,) => {




  return `/admin/bulk-reprocess/${id}/cancel`
}

export const cancelBulkReprocessRun = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<BulkReprocessRunIdDto> => {

  return customFetch<BulkReprocessRunIdDto>(getCancelBulkReprocessRunUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCancelBulkReprocessRunMutationKey = () => ['cancelBulkReprocessRun'] as const;

export const getCancelBulkReprocessRunMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelBulkReprocessRun>>, TError,CancelBulkReprocessRunMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelBulkReprocessRun>>, TError,CancelBulkReprocessRunMutationVariables, TContext> => {

const mutationKey = getCancelBulkReprocessRunMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelBulkReprocessRun>>, CancelBulkReprocessRunMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  cancelBulkReprocessRun(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelBulkReprocessRunMutationResult = NonNullable<Awaited<ReturnType<typeof cancelBulkReprocessRun>>>

    export type CancelBulkReprocessRunMutationError = unknown
    export type CancelBulkReprocessRunMutationVariables = {id: string}

    export const useCancelBulkReprocessRun = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelBulkReprocessRun>>, TError,CancelBulkReprocessRunMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelBulkReprocessRun>>,
        TError,
        CancelBulkReprocessRunMutationVariables,
        TContext
      > => {
      return useMutation(getCancelBulkReprocessRunMutationOptions(options), queryClient);
    }
